export type Lang = "es" | "en" | "zh" | "hi" | "ar" | "pt" | "fr" | "ru" | "ja" | "de" | "ko";

export const LANG_LABELS: Record<Lang, string> = {
  es: "Español",
  en: "English",
  zh: "中文",
  hi: "हिन्दी",
  ar: "العربية",
  pt: "Português",
  fr: "Français",
  ru: "Русский",
  ja: "日本語",
  de: "Deutsch",
  ko: "한국어",
};

const translations = {
  es: {
    dashboard: "Inicio",
    market: "Mercado",
    defi: "DeFi y NFTs",
    alerts: "Alertas",
    news: "Noticias",
    actions: "Acciones",
    myWallets: "Mis Wallets",
    totalBalance: "Balance Total",
    wallets: "billeteras",
    last24h: "Últimas 24h",
    refresh: "Actualizar",
    logout: "Cerrar sesión",
    quickActions: "Acciones rápidas",
    defiPositions: "Posiciones DeFi",
    total: "Total",
    rewards: "Recompensas",
    loading: "Cargando...",
    noPositions: "No se encontraron posiciones DeFi",
    enterAddress: "Introduce una dirección de wallet para ver posiciones DeFi reales",
    nftCollection: "Colección NFT",
    items: "artículos",
    priceAlerts: "Alertas de Precio",
    above: "Por encima de",
    below: "Por debajo de",
    createAlert: "Crear Alerta",
    noAlerts: "No hay alertas configuradas",
    notificationsEnabled: "Notificaciones activadas",
    enableNotifications: "Activar Notificaciones",
    cryptoNews: "Noticias Crypto",
    send: "Enviar",
    swap: "Swap",
    bridge: "Bridge",
    sendDesc: "Enviar crypto a otra wallet",
    swapDesc: "Intercambiar tokens",
    bridgeDesc: "Mover entre cadenas",
    network: "Red",
    destinationAddress: "Dirección de destino",
    amount: "Cantidad",
    sendTransaction: "Enviar Transacción",
    from: "De",
    to: "A",
    rate: "Tasa",
    slippage: "Slippage",
    estimatedGas: "Gas estimado",
    swapTokens: "Swap Tokens",
    fromChain: "Desde",
    toChain: "Hasta",
    tokenAmount: "Token & Cantidad",
    estimatedTime: "Tiempo estimado",
    bridgeFee: "Fee del bridge",
    bridgeTokens: "Bridge Tokens",
    fearGreed: "Fear & Greed",
    ethGas: "ETH Gas",
    topGainer: "Top Gainer",
    topLoser: "Top Loser",
    topByMarketCap: "Top 10 por Market Cap",
    language: "Idioma",
    currency: "Moneda",
    english: "English",
    // Auth
    signIn: "Iniciar Sesión",
    createAccount: "Crear Cuenta",
    name: "Nombre",
    email: "Email",
    password: "Contraseña",
    yourName: "Tu nombre",
    orContinueWith: "o continúa con",
    accountCreated: "¡Cuenta creada!",
    checkEmail: "Revisa tu email para confirmar tu cuenta.",
    backToLogin: "Volver al login",
    tagline: "Tu portfolio crypto seguro y unificado ✦",
    // Wallet
    addAddress: "Añadir dirección",
    connectWallet: "Conectar Wallet",
    addWallet: "Añadir Wallet",
    walletNamePlaceholder: "Nombre (ej: Mi MetaMask)",
    addressPlaceholder: "Dirección (0x... / bc1... / ...)",
    saveWallet: "Guardar Wallet",
    connectEvm: "Conectar EVM",
    connectPhantom: "Conectar Phantom",
    detected: "Detectado",
    installExtension: "Instalar extensión",
    private: "Privado",
    share: "Compartir",
    connected: "conectados",
    // Transactions
    sent: "Enviado",
    received: "Recibido",
    contract: "Contrato",
    loadingTransactions: "Cargando transacciones...",
    errorLoadingTx: "Error al cargar transacciones",
    apiLimits: "Las APIs gratuitas tienen límites de uso",
    noTransactions: "Sin transacciones encontradas",
    showingLast: "Mostrando últimas",
    transactions: "transacciones",
    clickToExplorer: "Click para ver en explorador",
    // Security
    securityNotifications: "Seguridad y Notificaciones",
    pushNotifications: "Notificaciones Push",
    notSupported: "No soportado en este navegador",
    enabled: "Activadas",
    blockedInBrowser: "Bloqueadas en el navegador",
    disabled: "Desactivadas",
    activate: "Activar",
    twoFactorAuth: "Verificación en 2 pasos (TOTP)",
    useAuthApp: "Usa Google Authenticator u otra app compatible",
    configuring: "Configurando...",
    setup2FA: "Configurar 2FA",
    scanQR: "Escanea este código QR con tu app de autenticación:",
    sixDigitCode: "Código de 6 dígitos",
    verify: "Verificar",
    twoFAEnabled: "2FA activado",
    twoFAEnabledDesc: "Tu cuenta ahora tiene verificación en dos pasos",
    invalidCode: "Código inválido",
    // Swap panel
    quickSwap: "Quick Swap",
    connectWalletFirst: "Conectar Wallet",
    // P&L
    noPnlData: "Sin datos de P&L disponibles",
    // Market
    source: "Fuente",
    gas: "Gas",
    installApp: "Instalar App",
    exportCsv: "Exportar CSV",
    onboardStep1Title: "Añade tus Wallets",
    onboardStep1Desc: "Conecta o añade manualmente wallets de Ethereum, Bitcoin, Solana y más.",
    onboardStep2Title: "Monitorea tu Portfolio",
    onboardStep2Desc: "Visualiza balances, gráficos, P&L y precios en tiempo real.",
    onboardStep3Title: "Seguridad Primero",
    onboardStep3Desc: "Tus claves nunca se almacenan. Solo lectura, siempre seguro.",
    onboardNext: "Siguiente",
    onboardStart: "¡Empezar!",
    search: "Buscar",
    goodMorning: "Buenos días",
    goodAfternoon: "Buenas tardes",
    goodEvening: "Buenas noches",
  },
  en: {
    dashboard: "Dashboard",
    market: "Market",
    defi: "DeFi & NFTs",
    alerts: "Alerts",
    news: "News",
    actions: "Actions",
    myWallets: "My Wallets",
    totalBalance: "Total Balance",
    wallets: "wallets",
    last24h: "Last 24h",
    refresh: "Refresh",
    logout: "Sign Out",
    quickActions: "Quick Actions",
    defiPositions: "DeFi Positions",
    total: "Total",
    rewards: "Rewards",
    loading: "Loading...",
    noPositions: "No DeFi positions found",
    enterAddress: "Enter a wallet address to see real DeFi positions",
    nftCollection: "NFT Collection",
    items: "items",
    priceAlerts: "Price Alerts",
    above: "Above",
    below: "Below",
    createAlert: "Create Alert",
    noAlerts: "No alerts configured",
    notificationsEnabled: "Notifications enabled",
    enableNotifications: "Enable Notifications",
    cryptoNews: "Crypto News",
    send: "Send",
    swap: "Swap",
    bridge: "Bridge",
    sendDesc: "Send crypto to another wallet",
    swapDesc: "Exchange tokens",
    bridgeDesc: "Move across chains",
    network: "Network",
    destinationAddress: "Destination address",
    amount: "Amount",
    sendTransaction: "Send Transaction",
    from: "From",
    to: "To",
    rate: "Rate",
    slippage: "Slippage",
    estimatedGas: "Est. Gas",
    swapTokens: "Swap Tokens",
    fromChain: "From",
    toChain: "To",
    tokenAmount: "Token & Amount",
    estimatedTime: "Estimated time",
    bridgeFee: "Bridge fee",
    bridgeTokens: "Bridge Tokens",
    fearGreed: "Fear & Greed",
    ethGas: "ETH Gas",
    topGainer: "Top Gainer",
    topLoser: "Top Loser",
    topByMarketCap: "Top 10 by Market Cap",
    language: "Language",
    currency: "Currency",
    english: "English",
    signIn: "Sign In",
    createAccount: "Create Account",
    name: "Name",
    email: "Email",
    password: "Password",
    yourName: "Your name",
    orContinueWith: "or continue with",
    accountCreated: "Account created!",
    checkEmail: "Check your email to confirm your account.",
    backToLogin: "Back to login",
    tagline: "Your secure & unified crypto portfolio ✦",
    addAddress: "Add address",
    connectWallet: "Connect Wallet",
    addWallet: "Add Wallet",
    walletNamePlaceholder: "Name (e.g. My MetaMask)",
    addressPlaceholder: "Address (0x... / bc1... / ...)",
    saveWallet: "Save Wallet",
    connectEvm: "Connect EVM",
    connectPhantom: "Connect Phantom",
    detected: "Detected",
    installExtension: "Install extension",
    private: "Private",
    share: "Share",
    connected: "connected",
    sent: "Sent",
    received: "Received",
    contract: "Contract",
    loadingTransactions: "Loading transactions...",
    errorLoadingTx: "Error loading transactions",
    apiLimits: "Free APIs have rate limits",
    noTransactions: "No transactions found",
    showingLast: "Showing last",
    transactions: "transactions",
    clickToExplorer: "Click to view in explorer",
    securityNotifications: "Security & Notifications",
    pushNotifications: "Push Notifications",
    notSupported: "Not supported in this browser",
    enabled: "Enabled",
    blockedInBrowser: "Blocked in browser",
    disabled: "Disabled",
    activate: "Activate",
    twoFactorAuth: "Two-Factor Auth (TOTP)",
    useAuthApp: "Use Google Authenticator or compatible app",
    configuring: "Configuring...",
    setup2FA: "Setup 2FA",
    scanQR: "Scan this QR code with your authenticator app:",
    sixDigitCode: "6-digit code",
    verify: "Verify",
    twoFAEnabled: "2FA enabled",
    twoFAEnabledDesc: "Your account now has two-step verification",
    invalidCode: "Invalid code",
    quickSwap: "Quick Swap",
    connectWalletFirst: "Connect Wallet",
    noPnlData: "No P&L data available",
    source: "Source",
    gas: "Gas",
    installApp: "Install App",
    exportCsv: "Export CSV",
    onboardStep1Title: "Add your Wallets",
    onboardStep1Desc: "Connect or manually add wallets from Ethereum, Bitcoin, Solana and more.",
    onboardStep2Title: "Monitor your Portfolio",
    onboardStep2Desc: "View balances, charts, P&L and real-time prices at a glance.",
    onboardStep3Title: "Security First",
    onboardStep3Desc: "Your keys are never stored. Read-only access, always safe.",
    onboardNext: "Next",
    onboardStart: "Get Started!",
    search: "Search",
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
  },
  zh: {
    dashboard: "仪表板",
    market: "市场",
    defi: "DeFi & NFTs",
    alerts: "提醒",
    news: "新闻",
    actions: "操作",
    myWallets: "我的钱包",
    totalBalance: "总余额",
    wallets: "钱包",
    last24h: "过去24小时",
    refresh: "刷新",
    logout: "退出",
    quickActions: "快捷操作",
    defiPositions: "DeFi 仓位",
    total: "总计",
    rewards: "奖励",
    loading: "加载中...",
    noPositions: "未找到DeFi仓位",
    enterAddress: "输入钱包地址以查看DeFi仓位",
    nftCollection: "NFT 收藏",
    items: "件",
    priceAlerts: "价格提醒",
    above: "高于",
    below: "低于",
    createAlert: "创建提醒",
    noAlerts: "暂无提醒",
    notificationsEnabled: "通知已开启",
    enableNotifications: "开启通知",
    cryptoNews: "加密新闻",
    send: "发送",
    swap: "兑换",
    bridge: "跨链",
    sendDesc: "发送加密货币到其他钱包",
    swapDesc: "代币兑换",
    bridgeDesc: "跨链转移",
    network: "网络",
    destinationAddress: "目标地址",
    amount: "数量",
    sendTransaction: "发送交易",
    from: "从",
    to: "到",
    rate: "汇率",
    slippage: "滑点",
    estimatedGas: "预估Gas",
    swapTokens: "兑换代币",
    fromChain: "来源链",
    toChain: "目标链",
    tokenAmount: "代币和数量",
    estimatedTime: "预估时间",
    bridgeFee: "跨链费用",
    bridgeTokens: "跨链转移",
    fearGreed: "恐惧与贪婪",
    ethGas: "ETH Gas",
    topGainer: "涨幅最大",
    topLoser: "跌幅最大",
    topByMarketCap: "市值前10",
    language: "语言",
    currency: "货币",
    english: "English",
    signIn: "登录",
    createAccount: "创建账户",
    name: "姓名",
    email: "邮箱",
    password: "密码",
    yourName: "您的姓名",
    orContinueWith: "或使用以下方式继续",
    accountCreated: "账户已创建！",
    checkEmail: "请检查邮箱确认您的账户。",
    backToLogin: "返回登录",
    tagline: "您的安全统一加密资产组合 ✦",
    addAddress: "添加地址",
    connectWallet: "连接钱包",
    addWallet: "添加钱包",
    walletNamePlaceholder: "名称（如：我的MetaMask）",
    addressPlaceholder: "地址 (0x... / bc1... / ...)",
    saveWallet: "保存钱包",
    connectEvm: "连接 EVM",
    connectPhantom: "连接 Phantom",
    detected: "已检测",
    installExtension: "安装扩展",
    private: "私密",
    share: "分享",
    connected: "已连接",
    sent: "已发送",
    received: "已接收",
    contract: "合约",
    loadingTransactions: "加载交易中...",
    errorLoadingTx: "加载交易出错",
    apiLimits: "免费API有速率限制",
    noTransactions: "未找到交易",
    showingLast: "显示最近",
    transactions: "笔交易",
    clickToExplorer: "点击在区块浏览器中查看",
    securityNotifications: "安全与通知",
    pushNotifications: "推送通知",
    notSupported: "此浏览器不支持",
    enabled: "已开启",
    blockedInBrowser: "已在浏览器中屏蔽",
    disabled: "已关闭",
    activate: "开启",
    twoFactorAuth: "两步验证 (TOTP)",
    useAuthApp: "使用Google Authenticator或兼容应用",
    configuring: "配置中...",
    setup2FA: "设置2FA",
    scanQR: "用认证器应用扫描此二维码：",
    sixDigitCode: "6位验证码",
    verify: "验证",
    twoFAEnabled: "2FA已启用",
    twoFAEnabledDesc: "您的账户现已开启两步验证",
    invalidCode: "验证码无效",
    quickSwap: "快速兑换",
    connectWalletFirst: "连接钱包",
    noPnlData: "暂无盈亏数据",
    source: "来源",
    gas: "Gas",
    installApp: "安装应用",
    exportCsv: "导出CSV",
    onboardStep1Title: "添加钱包",
    onboardStep1Desc: "连接或手动添加以太坊、比特币、Solana等钱包。",
    onboardStep2Title: "监控投资组合",
    onboardStep2Desc: "查看余额、图表、盈亏和实时价格。",
    onboardStep3Title: "安全第一",
    onboardStep3Desc: "您的密钥永不存储。仅只读访问，始终安全。",
    onboardNext: "下一步",
    onboardStart: "开始！",
    search: "搜索",
    goodMorning: "早上好",
    goodAfternoon: "下午好",
    goodEvening: "晚上好",
  },
  hi: {
    dashboard: "डैशबोर्ड",
    market: "बाज़ार",
    defi: "DeFi & NFTs",
    alerts: "अलर्ट",
    news: "समाचार",
    actions: "कार्य",
    myWallets: "मेरे वॉलेट",
    totalBalance: "कुल शेष",
    wallets: "वॉलेट",
    last24h: "पिछले 24 घंटे",
    refresh: "रिफ्रेश",
    logout: "लॉगआउट",
    quickActions: "त्वरित कार्य",
    defiPositions: "DeFi पोज़ीशन",
    total: "कुल",
    rewards: "पुरस्कार",
    loading: "लोड हो रहा है...",
    noPositions: "कोई DeFi पोज़ीशन नहीं मिली",
    enterAddress: "DeFi पोज़ीशन देखने के लिए वॉलेट पता दर्ज करें",
    nftCollection: "NFT संग्रह",
    items: "आइटम",
    priceAlerts: "मूल्य अलर्ट",
    above: "से ऊपर",
    below: "से नीचे",
    createAlert: "अलर्ट बनाएं",
    noAlerts: "कोई अलर्ट कॉन्फ़िगर नहीं",
    notificationsEnabled: "सूचनाएं सक्रिय",
    enableNotifications: "सूचनाएं सक्रिय करें",
    cryptoNews: "क्रिप्टो समाचार",
    send: "भेजें",
    swap: "स्वैप",
    bridge: "ब्रिज",
    sendDesc: "दूसरे वॉलेट को क्रिप्टो भेजें",
    swapDesc: "टोकन एक्सचेंज करें",
    bridgeDesc: "चेन के बीच मूव करें",
    network: "नेटवर्क",
    destinationAddress: "गंतव्य पता",
    amount: "राशि",
    sendTransaction: "ट्रांज़ैक्शन भेजें",
    from: "से",
    to: "को",
    rate: "दर",
    slippage: "स्लिपेज",
    estimatedGas: "अनुमानित Gas",
    swapTokens: "टोकन स्वैप",
    fromChain: "से",
    toChain: "तक",
    tokenAmount: "टोकन और राशि",
    estimatedTime: "अनुमानित समय",
    bridgeFee: "ब्रिज शुल्क",
    bridgeTokens: "ब्रिज टोकन",
    fearGreed: "भय और लालच",
    ethGas: "ETH Gas",
    topGainer: "शीर्ष गेनर",
    topLoser: "शीर्ष लूज़र",
    topByMarketCap: "मार्केट कैप द्वारा शीर्ष 10",
    language: "भाषा",
    currency: "मुद्रा",
    english: "English",
    signIn: "साइन इन",
    createAccount: "खाता बनाएं",
    name: "नाम",
    email: "ईमेल",
    password: "पासवर्ड",
    yourName: "आपका नाम",
    orContinueWith: "या इसके साथ जारी रखें",
    accountCreated: "खाता बन गया!",
    checkEmail: "अपना ईमेल चेक करके खाता कन्फ़र्म करें।",
    backToLogin: "लॉगिन पर वापस",
    tagline: "आपका सुरक्षित एकीकृत क्रिप्टो पोर्टफोलियो ✦",
    addAddress: "पता जोड़ें",
    connectWallet: "वॉलेट कनेक्ट करें",
    addWallet: "वॉलेट जोड़ें",
    walletNamePlaceholder: "नाम (जैसे: मेरा MetaMask)",
    addressPlaceholder: "पता (0x... / bc1... / ...)",
    saveWallet: "वॉलेट सहेजें",
    connectEvm: "EVM कनेक्ट",
    connectPhantom: "Phantom कनेक्ट",
    detected: "पाया गया",
    installExtension: "एक्सटेंशन इंस्टॉल करें",
    private: "प्राइवेट",
    share: "शेयर",
    connected: "कनेक्टेड",
    sent: "भेजा गया",
    received: "प्राप्त हुआ",
    contract: "कॉन्ट्रैक्ट",
    loadingTransactions: "ट्रांज़ैक्शन लोड हो रहे हैं...",
    errorLoadingTx: "ट्रांज़ैक्शन लोड करने में त्रुटि",
    apiLimits: "मुफ्त API की दर सीमा है",
    noTransactions: "कोई ट्रांज़ैक्शन नहीं मिला",
    showingLast: "अंतिम दिखा रहे हैं",
    transactions: "ट्रांज़ैक्शन",
    clickToExplorer: "एक्सप्लोरर में देखने के लिए क्लिक करें",
    securityNotifications: "सुरक्षा और सूचनाएं",
    pushNotifications: "पुश सूचनाएं",
    notSupported: "इस ब्राउज़र में उपलब्ध नहीं",
    enabled: "सक्रिय",
    blockedInBrowser: "ब्राउज़र में ब्लॉक",
    disabled: "निष्क्रिय",
    activate: "सक्रिय करें",
    twoFactorAuth: "दो-चरण सत्यापन (TOTP)",
    useAuthApp: "Google Authenticator या संगत ऐप का उपयोग करें",
    configuring: "कॉन्फ़िगर हो रहा है...",
    setup2FA: "2FA सेटअप",
    scanQR: "अपने ऑथेंटिकेटर ऐप से इस QR कोड को स्कैन करें:",
    sixDigitCode: "6 अंकों का कोड",
    verify: "सत्यापित करें",
    twoFAEnabled: "2FA सक्रिय",
    twoFAEnabledDesc: "आपके खाते में अब दो-चरण सत्यापन है",
    invalidCode: "अमान्य कोड",
    quickSwap: "क्विक स्वैप",
    connectWalletFirst: "वॉलेट कनेक्ट करें",
    noPnlData: "कोई P&L डेटा उपलब्ध नहीं",
    source: "स्रोत",
    gas: "Gas",
    installApp: "ऐप इंस्टॉल करें",
    exportCsv: "CSV निर्यात",
    onboardStep1Title: "अपने वॉलेट जोड़ें",
    onboardStep1Desc: "Ethereum, Bitcoin, Solana आदि से वॉलेट कनेक्ट या मैन्युअली जोड़ें।",
    onboardStep2Title: "पोर्टफोलियो मॉनिटर करें",
    onboardStep2Desc: "बैलेंस, चार्ट, P&L और रियल-टाइम कीमतें देखें।",
    onboardStep3Title: "सुरक्षा पहले",
    onboardStep3Desc: "आपकी कुंजियाँ कभी संग्रहीत नहीं होतीं। केवल-पठन, हमेशा सुरक्षित।",
    onboardNext: "अगला",
    onboardStart: "शुरू करें!",
    search: "खोजें",
    goodMorning: "सुप्रभात",
    goodAfternoon: "नमस्कार",
    goodEvening: "शुभ संध्या",
  },
  ar: {
    dashboard: "لوحة التحكم",
    market: "السوق",
    defi: "DeFi & NFTs",
    alerts: "تنبيهات",
    news: "أخبار",
    actions: "إجراءات",
    myWallets: "محافظي",
    totalBalance: "الرصيد الإجمالي",
    wallets: "محافظ",
    last24h: "آخر 24 ساعة",
    refresh: "تحديث",
    logout: "تسجيل الخروج",
    quickActions: "إجراءات سريعة",
    defiPositions: "مراكز DeFi",
    total: "الإجمالي",
    rewards: "المكافآت",
    loading: "جاري التحميل...",
    noPositions: "لم يتم العثور على مراكز DeFi",
    enterAddress: "أدخل عنوان المحفظة لعرض مراكز DeFi",
    nftCollection: "مجموعة NFT",
    items: "عناصر",
    priceAlerts: "تنبيهات الأسعار",
    above: "أعلى من",
    below: "أقل من",
    createAlert: "إنشاء تنبيه",
    noAlerts: "لا توجد تنبيهات",
    notificationsEnabled: "الإشعارات مفعلة",
    enableNotifications: "تفعيل الإشعارات",
    cryptoNews: "أخبار الكريبتو",
    send: "إرسال",
    swap: "مبادلة",
    bridge: "جسر",
    sendDesc: "إرسال كريبتو إلى محفظة أخرى",
    swapDesc: "تبادل الرموز",
    bridgeDesc: "النقل بين الشبكات",
    network: "الشبكة",
    destinationAddress: "عنوان الوجهة",
    amount: "المبلغ",
    sendTransaction: "إرسال المعاملة",
    from: "من",
    to: "إلى",
    rate: "السعر",
    slippage: "الانزلاق",
    estimatedGas: "Gas المقدر",
    swapTokens: "مبادلة الرموز",
    fromChain: "من",
    toChain: "إلى",
    tokenAmount: "الرمز والمبلغ",
    estimatedTime: "الوقت المقدر",
    bridgeFee: "رسوم الجسر",
    bridgeTokens: "نقل الرموز",
    fearGreed: "الخوف والطمع",
    ethGas: "ETH Gas",
    topGainer: "أعلى ارتفاع",
    topLoser: "أعلى انخفاض",
    topByMarketCap: "أعلى 10 حسب القيمة السوقية",
    language: "اللغة",
    currency: "العملة",
    english: "English",
    signIn: "تسجيل الدخول",
    createAccount: "إنشاء حساب",
    name: "الاسم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    yourName: "اسمك",
    orContinueWith: "أو تابع باستخدام",
    accountCreated: "تم إنشاء الحساب!",
    checkEmail: "تحقق من بريدك الإلكتروني لتأكيد حسابك.",
    backToLogin: "العودة لتسجيل الدخول",
    tagline: "محفظة كريبتو آمنة وموحدة ✦",
    addAddress: "إضافة عنوان",
    connectWallet: "ربط المحفظة",
    addWallet: "إضافة محفظة",
    walletNamePlaceholder: "الاسم (مثال: MetaMask)",
    addressPlaceholder: "العنوان (0x... / bc1... / ...)",
    saveWallet: "حفظ المحفظة",
    connectEvm: "ربط EVM",
    connectPhantom: "ربط Phantom",
    detected: "تم الكشف",
    installExtension: "تثبيت الإضافة",
    private: "خاص",
    share: "مشاركة",
    connected: "متصل",
    sent: "مُرسل",
    received: "مُستلم",
    contract: "عقد",
    loadingTransactions: "جاري تحميل المعاملات...",
    errorLoadingTx: "خطأ في تحميل المعاملات",
    apiLimits: "واجهات API المجانية لها حدود",
    noTransactions: "لم يتم العثور على معاملات",
    showingLast: "عرض آخر",
    transactions: "معاملات",
    clickToExplorer: "انقر للعرض في المستكشف",
    securityNotifications: "الأمان والإشعارات",
    pushNotifications: "الإشعارات الفورية",
    notSupported: "غير مدعوم في هذا المتصفح",
    enabled: "مفعل",
    blockedInBrowser: "محظور في المتصفح",
    disabled: "معطل",
    activate: "تفعيل",
    twoFactorAuth: "التحقق بخطوتين (TOTP)",
    useAuthApp: "استخدم Google Authenticator أو تطبيق متوافق",
    configuring: "جاري الإعداد...",
    setup2FA: "إعداد 2FA",
    scanQR: "امسح رمز QR بتطبيق المصادقة:",
    sixDigitCode: "رمز من 6 أرقام",
    verify: "تحقق",
    twoFAEnabled: "تم تفعيل 2FA",
    twoFAEnabledDesc: "حسابك الآن محمي بالتحقق بخطوتين",
    invalidCode: "رمز غير صالح",
    quickSwap: "مبادلة سريعة",
    connectWalletFirst: "ربط المحفظة",
    noPnlData: "لا توجد بيانات أرباح وخسائر",
    source: "المصدر",
    gas: "Gas",
    installApp: "تثبيت التطبيق",
    exportCsv: "تصدير CSV",
    onboardStep1Title: "أضف محافظك",
    onboardStep1Desc: "قم بتوصيل أو إضافة محافظ Ethereum وBitcoin وSolana يدويًا.",
    onboardStep2Title: "راقب محفظتك",
    onboardStep2Desc: "عرض الأرصدة والرسوم البيانية والأرباح والأسعار الفورية.",
    onboardStep3Title: "الأمان أولاً",
    onboardStep3Desc: "لن يتم تخزين مفاتيحك أبدًا. وصول للقراءة فقط، آمن دائمًا.",
    onboardNext: "التالي",
    onboardStart: "ابدأ!",
    search: "بحث",
    goodMorning: "صباح الخير",
    goodAfternoon: "مساء الخير",
    goodEvening: "مساء الخير",
  },
  pt: {
    dashboard: "Painel",
    market: "Mercado",
    defi: "DeFi & NFTs",
    alerts: "Alertas",
    news: "Notícias",
    actions: "Ações",
    myWallets: "Minhas Carteiras",
    totalBalance: "Saldo Total",
    wallets: "carteiras",
    last24h: "Últimas 24h",
    refresh: "Atualizar",
    logout: "Sair",
    quickActions: "Ações Rápidas",
    defiPositions: "Posições DeFi",
    total: "Total",
    rewards: "Recompensas",
    loading: "Carregando...",
    noPositions: "Nenhuma posição DeFi encontrada",
    enterAddress: "Insira um endereço de carteira para ver posições DeFi",
    nftCollection: "Coleção NFT",
    items: "itens",
    priceAlerts: "Alertas de Preço",
    above: "Acima de",
    below: "Abaixo de",
    createAlert: "Criar Alerta",
    noAlerts: "Nenhum alerta configurado",
    notificationsEnabled: "Notificações ativadas",
    enableNotifications: "Ativar Notificações",
    cryptoNews: "Notícias Crypto",
    send: "Enviar",
    swap: "Trocar",
    bridge: "Bridge",
    sendDesc: "Enviar crypto para outra carteira",
    swapDesc: "Trocar tokens",
    bridgeDesc: "Mover entre redes",
    network: "Rede",
    destinationAddress: "Endereço de destino",
    amount: "Quantidade",
    sendTransaction: "Enviar Transação",
    from: "De",
    to: "Para",
    rate: "Taxa",
    slippage: "Slippage",
    estimatedGas: "Gas estimado",
    swapTokens: "Trocar Tokens",
    fromChain: "De",
    toChain: "Para",
    tokenAmount: "Token e Quantidade",
    estimatedTime: "Tempo estimado",
    bridgeFee: "Taxa do bridge",
    bridgeTokens: "Bridge Tokens",
    fearGreed: "Medo e Ganância",
    ethGas: "ETH Gas",
    topGainer: "Maior Alta",
    topLoser: "Maior Queda",
    topByMarketCap: "Top 10 por Market Cap",
    language: "Idioma",
    currency: "Moeda",
    english: "English",
    signIn: "Entrar",
    createAccount: "Criar Conta",
    name: "Nome",
    email: "Email",
    password: "Senha",
    yourName: "Seu nome",
    orContinueWith: "ou continue com",
    accountCreated: "Conta criada!",
    checkEmail: "Verifique seu email para confirmar sua conta.",
    backToLogin: "Voltar ao login",
    tagline: "Seu portfólio crypto seguro e unificado ✦",
    addAddress: "Adicionar endereço",
    connectWallet: "Conectar Carteira",
    addWallet: "Adicionar Carteira",
    walletNamePlaceholder: "Nome (ex: Meu MetaMask)",
    addressPlaceholder: "Endereço (0x... / bc1... / ...)",
    saveWallet: "Salvar Carteira",
    connectEvm: "Conectar EVM",
    connectPhantom: "Conectar Phantom",
    detected: "Detectado",
    installExtension: "Instalar extensão",
    private: "Privado",
    share: "Compartilhar",
    connected: "conectadas",
    sent: "Enviado",
    received: "Recebido",
    contract: "Contrato",
    loadingTransactions: "Carregando transações...",
    errorLoadingTx: "Erro ao carregar transações",
    apiLimits: "APIs gratuitas têm limites de uso",
    noTransactions: "Nenhuma transação encontrada",
    showingLast: "Mostrando últimas",
    transactions: "transações",
    clickToExplorer: "Clique para ver no explorador",
    securityNotifications: "Segurança e Notificações",
    pushNotifications: "Notificações Push",
    notSupported: "Não suportado neste navegador",
    enabled: "Ativadas",
    blockedInBrowser: "Bloqueadas no navegador",
    disabled: "Desativadas",
    activate: "Ativar",
    twoFactorAuth: "Verificação em 2 etapas (TOTP)",
    useAuthApp: "Use Google Authenticator ou app compatível",
    configuring: "Configurando...",
    setup2FA: "Configurar 2FA",
    scanQR: "Escaneie este QR com seu app autenticador:",
    sixDigitCode: "Código de 6 dígitos",
    verify: "Verificar",
    twoFAEnabled: "2FA ativado",
    twoFAEnabledDesc: "Sua conta agora tem verificação em duas etapas",
    invalidCode: "Código inválido",
    quickSwap: "Troca Rápida",
    connectWalletFirst: "Conectar Carteira",
    noPnlData: "Sem dados de P&L disponíveis",
    source: "Fonte",
    gas: "Gas",
    installApp: "Instalar App",
    exportCsv: "Exportar CSV",
    onboardStep1Title: "Adicione suas Carteiras",
    onboardStep1Desc: "Conecte ou adicione carteiras de Ethereum, Bitcoin, Solana e mais.",
    onboardStep2Title: "Monitore seu Portfólio",
    onboardStep2Desc: "Veja saldos, gráficos, P&L e preços em tempo real.",
    onboardStep3Title: "Segurança em Primeiro",
    onboardStep3Desc: "Suas chaves nunca são armazenadas. Acesso somente leitura, sempre seguro.",
    onboardNext: "Próximo",
    onboardStart: "Começar!",
    search: "Pesquisar",
    goodMorning: "Bom dia",
    goodAfternoon: "Boa tarde",
    goodEvening: "Boa noite",
  },
  fr: {
    dashboard: "Tableau de bord",
    market: "Marché",
    defi: "DeFi & NFTs",
    alerts: "Alertes",
    news: "Actualités",
    actions: "Actions",
    myWallets: "Mes Portefeuilles",
    totalBalance: "Solde Total",
    wallets: "portefeuilles",
    last24h: "Dernières 24h",
    refresh: "Actualiser",
    logout: "Déconnexion",
    quickActions: "Actions Rapides",
    defiPositions: "Positions DeFi",
    total: "Total",
    rewards: "Récompenses",
    loading: "Chargement...",
    noPositions: "Aucune position DeFi trouvée",
    enterAddress: "Entrez une adresse pour voir les positions DeFi",
    nftCollection: "Collection NFT",
    items: "éléments",
    priceAlerts: "Alertes de Prix",
    above: "Au-dessus de",
    below: "En-dessous de",
    createAlert: "Créer une Alerte",
    noAlerts: "Aucune alerte configurée",
    notificationsEnabled: "Notifications activées",
    enableNotifications: "Activer les Notifications",
    cryptoNews: "Actualités Crypto",
    send: "Envoyer",
    swap: "Échanger",
    bridge: "Bridge",
    sendDesc: "Envoyer des crypto à un autre portefeuille",
    swapDesc: "Échanger des tokens",
    bridgeDesc: "Transférer entre chaînes",
    network: "Réseau",
    destinationAddress: "Adresse de destination",
    amount: "Montant",
    sendTransaction: "Envoyer la Transaction",
    from: "De",
    to: "À",
    rate: "Taux",
    slippage: "Slippage",
    estimatedGas: "Gas estimé",
    swapTokens: "Échanger les Tokens",
    fromChain: "Depuis",
    toChain: "Vers",
    tokenAmount: "Token & Montant",
    estimatedTime: "Temps estimé",
    bridgeFee: "Frais de bridge",
    bridgeTokens: "Bridge Tokens",
    fearGreed: "Peur et Avidité",
    ethGas: "ETH Gas",
    topGainer: "Plus forte hausse",
    topLoser: "Plus forte baisse",
    topByMarketCap: "Top 10 par capitalisation",
    language: "Langue",
    currency: "Devise",
    english: "English",
    signIn: "Se connecter",
    createAccount: "Créer un Compte",
    name: "Nom",
    email: "Email",
    password: "Mot de passe",
    yourName: "Votre nom",
    orContinueWith: "ou continuez avec",
    accountCreated: "Compte créé !",
    checkEmail: "Vérifiez votre email pour confirmer votre compte.",
    backToLogin: "Retour à la connexion",
    tagline: "Votre portfolio crypto sécurisé et unifié ✦",
    addAddress: "Ajouter une adresse",
    connectWallet: "Connecter le Portefeuille",
    addWallet: "Ajouter un Portefeuille",
    walletNamePlaceholder: "Nom (ex : Mon MetaMask)",
    addressPlaceholder: "Adresse (0x... / bc1... / ...)",
    saveWallet: "Enregistrer",
    connectEvm: "Connecter EVM",
    connectPhantom: "Connecter Phantom",
    detected: "Détecté",
    installExtension: "Installer l'extension",
    private: "Privé",
    share: "Partager",
    connected: "connectés",
    sent: "Envoyé",
    received: "Reçu",
    contract: "Contrat",
    loadingTransactions: "Chargement des transactions...",
    errorLoadingTx: "Erreur lors du chargement",
    apiLimits: "Les API gratuites ont des limites",
    noTransactions: "Aucune transaction trouvée",
    showingLast: "Affichage des",
    transactions: "dernières transactions",
    clickToExplorer: "Cliquez pour voir dans l'explorateur",
    securityNotifications: "Sécurité et Notifications",
    pushNotifications: "Notifications Push",
    notSupported: "Non supporté dans ce navigateur",
    enabled: "Activées",
    blockedInBrowser: "Bloquées dans le navigateur",
    disabled: "Désactivées",
    activate: "Activer",
    twoFactorAuth: "Vérification en 2 étapes (TOTP)",
    useAuthApp: "Utilisez Google Authenticator ou app compatible",
    configuring: "Configuration...",
    setup2FA: "Configurer 2FA",
    scanQR: "Scannez ce QR avec votre app d'authentification :",
    sixDigitCode: "Code à 6 chiffres",
    verify: "Vérifier",
    twoFAEnabled: "2FA activé",
    twoFAEnabledDesc: "Votre compte a maintenant la vérification en deux étapes",
    invalidCode: "Code invalide",
    quickSwap: "Échange Rapide",
    connectWalletFirst: "Connecter le Portefeuille",
    noPnlData: "Aucune donnée P&L disponible",
    source: "Source",
    gas: "Gas",
    installApp: "Installer l'app",
    exportCsv: "Exporter CSV",
    onboardStep1Title: "Ajoutez vos Wallets",
    onboardStep1Desc: "Connectez ou ajoutez manuellement des wallets Ethereum, Bitcoin, Solana et plus.",
    onboardStep2Title: "Surveillez votre Portfolio",
    onboardStep2Desc: "Visualisez soldes, graphiques, P&L et prix en temps réel.",
    onboardStep3Title: "Sécurité d'abord",
    onboardStep3Desc: "Vos clés ne sont jamais stockées. Accès en lecture seule, toujours sécurisé.",
    onboardNext: "Suivant",
    onboardStart: "Commencer !",
    search: "Rechercher",
    goodMorning: "Bonjour",
    goodAfternoon: "Bon après-midi",
    goodEvening: "Bonsoir",
  },
  ru: {
    dashboard: "Панель",
    market: "Рынок",
    defi: "DeFi & NFTs",
    alerts: "Оповещения",
    news: "Новости",
    actions: "Действия",
    myWallets: "Мои Кошельки",
    totalBalance: "Общий Баланс",
    wallets: "кошельков",
    last24h: "За 24 часа",
    refresh: "Обновить",
    logout: "Выйти",
    quickActions: "Быстрые Действия",
    defiPositions: "Позиции DeFi",
    total: "Всего",
    rewards: "Награды",
    loading: "Загрузка...",
    noPositions: "Позиции DeFi не найдены",
    enterAddress: "Введите адрес кошелька для просмотра позиций DeFi",
    nftCollection: "Коллекция NFT",
    items: "элементов",
    priceAlerts: "Ценовые Оповещения",
    above: "Выше",
    below: "Ниже",
    createAlert: "Создать Оповещение",
    noAlerts: "Нет настроенных оповещений",
    notificationsEnabled: "Уведомления включены",
    enableNotifications: "Включить Уведомления",
    cryptoNews: "Крипто Новости",
    send: "Отправить",
    swap: "Обмен",
    bridge: "Мост",
    sendDesc: "Отправить крипту на другой кошелёк",
    swapDesc: "Обменять токены",
    bridgeDesc: "Перевести между сетями",
    network: "Сеть",
    destinationAddress: "Адрес назначения",
    amount: "Сумма",
    sendTransaction: "Отправить Транзакцию",
    from: "От",
    to: "Кому",
    rate: "Курс",
    slippage: "Проскальзывание",
    estimatedGas: "Ориент. Gas",
    swapTokens: "Обменять Токены",
    fromChain: "Из",
    toChain: "В",
    tokenAmount: "Токен и Сумма",
    estimatedTime: "Примерное время",
    bridgeFee: "Комиссия моста",
    bridgeTokens: "Перевести Токены",
    fearGreed: "Страх и Жадность",
    ethGas: "ETH Gas",
    topGainer: "Лидер роста",
    topLoser: "Лидер падения",
    topByMarketCap: "Топ 10 по капитализации",
    language: "Язык",
    currency: "Валюта",
    english: "English",
    signIn: "Войти",
    createAccount: "Создать Аккаунт",
    name: "Имя",
    email: "Эл. почта",
    password: "Пароль",
    yourName: "Ваше имя",
    orContinueWith: "или продолжите через",
    accountCreated: "Аккаунт создан!",
    checkEmail: "Проверьте почту для подтверждения аккаунта.",
    backToLogin: "Вернуться ко входу",
    tagline: "Ваш безопасный крипто-портфель ✦",
    addAddress: "Добавить адрес",
    connectWallet: "Подключить Кошелёк",
    addWallet: "Добавить Кошелёк",
    walletNamePlaceholder: "Название (напр.: Мой MetaMask)",
    addressPlaceholder: "Адрес (0x... / bc1... / ...)",
    saveWallet: "Сохранить",
    connectEvm: "Подключить EVM",
    connectPhantom: "Подключить Phantom",
    detected: "Обнаружен",
    installExtension: "Установить расширение",
    private: "Приватный",
    share: "Поделиться",
    connected: "подключено",
    sent: "Отправлено",
    received: "Получено",
    contract: "Контракт",
    loadingTransactions: "Загрузка транзакций...",
    errorLoadingTx: "Ошибка загрузки транзакций",
    apiLimits: "Бесплатные API имеют ограничения",
    noTransactions: "Транзакции не найдены",
    showingLast: "Показаны последние",
    transactions: "транзакций",
    clickToExplorer: "Нажмите для просмотра в обозревателе",
    securityNotifications: "Безопасность и Уведомления",
    pushNotifications: "Push-уведомления",
    notSupported: "Не поддерживается в этом браузере",
    enabled: "Включены",
    blockedInBrowser: "Заблокированы в браузере",
    disabled: "Отключены",
    activate: "Включить",
    twoFactorAuth: "Двухфакторная аутентификация (TOTP)",
    useAuthApp: "Используйте Google Authenticator или совместимое приложение",
    configuring: "Настройка...",
    setup2FA: "Настроить 2FA",
    scanQR: "Отсканируйте QR-код приложением аутентификации:",
    sixDigitCode: "6-значный код",
    verify: "Подтвердить",
    twoFAEnabled: "2FA включена",
    twoFAEnabledDesc: "Ваш аккаунт теперь защищён двухфакторной аутентификацией",
    invalidCode: "Неверный код",
    quickSwap: "Быстрый Обмен",
    connectWalletFirst: "Подключить Кошелёк",
    noPnlData: "Нет данных о P&L",
    source: "Источник",
    gas: "Gas",
    installApp: "Установить приложение",
    exportCsv: "Экспорт CSV",
    onboardStep1Title: "Добавьте кошельки",
    onboardStep1Desc: "Подключите или добавьте вручную кошельки Ethereum, Bitcoin, Solana и другие.",
    onboardStep2Title: "Следите за портфелем",
    onboardStep2Desc: "Просматривайте балансы, графики, P&L и цены в реальном времени.",
    onboardStep3Title: "Безопасность прежде всего",
    onboardStep3Desc: "Ваши ключи никогда не сохраняются. Только чтение, всегда безопасно.",
    onboardNext: "Далее",
    onboardStart: "Начать!",
    search: "Поиск",
    goodMorning: "Доброе утро",
    goodAfternoon: "Добрый день",
    goodEvening: "Добрый вечер",
  },
  ja: {
    dashboard: "ダッシュボード",
    market: "マーケット",
    defi: "DeFi & NFTs",
    alerts: "アラート",
    news: "ニュース",
    actions: "アクション",
    myWallets: "マイウォレット",
    totalBalance: "合計残高",
    wallets: "ウォレット",
    last24h: "過去24時間",
    refresh: "更新",
    logout: "ログアウト",
    quickActions: "クイックアクション",
    defiPositions: "DeFiポジション",
    total: "合計",
    rewards: "報酬",
    loading: "読み込み中...",
    noPositions: "DeFiポジションが見つかりません",
    enterAddress: "ウォレットアドレスを入力してDeFiポジションを確認",
    nftCollection: "NFTコレクション",
    items: "アイテム",
    priceAlerts: "価格アラート",
    above: "以上",
    below: "以下",
    createAlert: "アラート作成",
    noAlerts: "アラートなし",
    notificationsEnabled: "通知有効",
    enableNotifications: "通知を有効にする",
    cryptoNews: "暗号通貨ニュース",
    send: "送金",
    swap: "スワップ",
    bridge: "ブリッジ",
    sendDesc: "他のウォレットに暗号通貨を送る",
    swapDesc: "トークンを交換",
    bridgeDesc: "チェーン間で移動",
    network: "ネットワーク",
    destinationAddress: "送信先アドレス",
    amount: "数量",
    sendTransaction: "トランザクション送信",
    from: "送信元",
    to: "送信先",
    rate: "レート",
    slippage: "スリッページ",
    estimatedGas: "推定Gas",
    swapTokens: "トークンスワップ",
    fromChain: "送信元",
    toChain: "送信先",
    tokenAmount: "トークンと数量",
    estimatedTime: "推定時間",
    bridgeFee: "ブリッジ手数料",
    bridgeTokens: "ブリッジ送信",
    fearGreed: "恐怖と強欲",
    ethGas: "ETH Gas",
    topGainer: "上昇率トップ",
    topLoser: "下落率トップ",
    topByMarketCap: "時価総額トップ10",
    language: "言語",
    currency: "通貨",
    english: "English",
    signIn: "ログイン",
    createAccount: "アカウント作成",
    name: "名前",
    email: "メール",
    password: "パスワード",
    yourName: "お名前",
    orContinueWith: "または次で続ける",
    accountCreated: "アカウント作成完了！",
    checkEmail: "メールを確認してアカウントを認証してください。",
    backToLogin: "ログインに戻る",
    tagline: "安全で統合された暗号資産ポートフォリオ ✦",
    addAddress: "アドレスを追加",
    connectWallet: "ウォレット接続",
    addWallet: "ウォレット追加",
    walletNamePlaceholder: "名前（例：My MetaMask）",
    addressPlaceholder: "アドレス (0x... / bc1... / ...)",
    saveWallet: "保存",
    connectEvm: "EVM接続",
    connectPhantom: "Phantom接続",
    detected: "検出済み",
    installExtension: "拡張機能をインストール",
    private: "プライベート",
    share: "共有",
    connected: "接続済み",
    sent: "送信済み",
    received: "受信済み",
    contract: "コントラクト",
    loadingTransactions: "トランザクション読み込み中...",
    errorLoadingTx: "トランザクション読み込みエラー",
    apiLimits: "無料APIにはレート制限があります",
    noTransactions: "トランザクションが見つかりません",
    showingLast: "最新",
    transactions: "件のトランザクション",
    clickToExplorer: "エクスプローラーで確認",
    securityNotifications: "セキュリティと通知",
    pushNotifications: "プッシュ通知",
    notSupported: "このブラウザでは未対応",
    enabled: "有効",
    blockedInBrowser: "ブラウザでブロック中",
    disabled: "無効",
    activate: "有効にする",
    twoFactorAuth: "二段階認証 (TOTP)",
    useAuthApp: "Google Authenticatorまたは互換アプリを使用",
    configuring: "設定中...",
    setup2FA: "2FAを設定",
    scanQR: "認証アプリでQRコードをスキャン：",
    sixDigitCode: "6桁のコード",
    verify: "確認",
    twoFAEnabled: "2FA有効",
    twoFAEnabledDesc: "アカウントが二段階認証で保護されました",
    invalidCode: "無効なコード",
    quickSwap: "クイックスワップ",
    connectWalletFirst: "ウォレット接続",
    noPnlData: "P&Lデータなし",
    source: "ソース",
    gas: "Gas",
    installApp: "アプリをインストール",
    exportCsv: "CSV出力",
    onboardStep1Title: "ウォレットを追加",
    onboardStep1Desc: "Ethereum、Bitcoin、Solanaなどのウォレットを接続または手動追加。",
    onboardStep2Title: "ポートフォリオを監視",
    onboardStep2Desc: "残高、チャート、損益、リアルタイム価格を確認。",
    onboardStep3Title: "セキュリティ最優先",
    onboardStep3Desc: "鍵は保存されません。読み取り専用、常に安全。",
    onboardNext: "次へ",
    onboardStart: "始める！",
    search: "検索",
    goodMorning: "おはようございます",
    goodAfternoon: "こんにちは",
    goodEvening: "こんばんは",
  },
  de: {
    dashboard: "Dashboard",
    market: "Markt",
    defi: "DeFi & NFTs",
    alerts: "Alarme",
    news: "Nachrichten",
    actions: "Aktionen",
    myWallets: "Meine Wallets",
    totalBalance: "Gesamtsaldo",
    wallets: "Wallets",
    last24h: "Letzte 24h",
    refresh: "Aktualisieren",
    logout: "Abmelden",
    quickActions: "Schnellaktionen",
    defiPositions: "DeFi-Positionen",
    total: "Gesamt",
    rewards: "Belohnungen",
    loading: "Wird geladen...",
    noPositions: "Keine DeFi-Positionen gefunden",
    enterAddress: "Wallet-Adresse eingeben um DeFi-Positionen anzuzeigen",
    nftCollection: "NFT-Sammlung",
    items: "Objekte",
    priceAlerts: "Preisalarme",
    above: "Über",
    below: "Unter",
    createAlert: "Alarm erstellen",
    noAlerts: "Keine Alarme konfiguriert",
    notificationsEnabled: "Benachrichtigungen aktiviert",
    enableNotifications: "Benachrichtigungen aktivieren",
    cryptoNews: "Krypto-Nachrichten",
    send: "Senden",
    swap: "Tauschen",
    bridge: "Bridge",
    sendDesc: "Krypto an ein anderes Wallet senden",
    swapDesc: "Token tauschen",
    bridgeDesc: "Zwischen Chains bewegen",
    network: "Netzwerk",
    destinationAddress: "Zieladresse",
    amount: "Betrag",
    sendTransaction: "Transaktion senden",
    from: "Von",
    to: "An",
    rate: "Kurs",
    slippage: "Slippage",
    estimatedGas: "Geschätztes Gas",
    swapTokens: "Token Tauschen",
    fromChain: "Von",
    toChain: "Nach",
    tokenAmount: "Token & Betrag",
    estimatedTime: "Geschätzte Zeit",
    bridgeFee: "Bridge-Gebühr",
    bridgeTokens: "Bridge Tokens",
    fearGreed: "Angst & Gier",
    ethGas: "ETH Gas",
    topGainer: "Top Gewinner",
    topLoser: "Top Verlierer",
    topByMarketCap: "Top 10 nach Marktkapitalisierung",
    language: "Sprache",
    currency: "Währung",
    english: "English",
    signIn: "Anmelden",
    createAccount: "Konto erstellen",
    name: "Name",
    email: "E-Mail",
    password: "Passwort",
    yourName: "Dein Name",
    orContinueWith: "oder weiter mit",
    accountCreated: "Konto erstellt!",
    checkEmail: "Überprüfe deine E-Mail zur Bestätigung.",
    backToLogin: "Zurück zum Login",
    tagline: "Dein sicheres & einheitliches Krypto-Portfolio ✦",
    addAddress: "Adresse hinzufügen",
    connectWallet: "Wallet verbinden",
    addWallet: "Wallet hinzufügen",
    walletNamePlaceholder: "Name (z.B.: Mein MetaMask)",
    addressPlaceholder: "Adresse (0x... / bc1... / ...)",
    saveWallet: "Speichern",
    connectEvm: "EVM verbinden",
    connectPhantom: "Phantom verbinden",
    detected: "Erkannt",
    installExtension: "Erweiterung installieren",
    private: "Privat",
    share: "Teilen",
    connected: "verbunden",
    sent: "Gesendet",
    received: "Empfangen",
    contract: "Vertrag",
    loadingTransactions: "Transaktionen werden geladen...",
    errorLoadingTx: "Fehler beim Laden der Transaktionen",
    apiLimits: "Kostenlose APIs haben Ratenlimits",
    noTransactions: "Keine Transaktionen gefunden",
    showingLast: "Letzte",
    transactions: "Transaktionen angezeigt",
    clickToExplorer: "Klicken zum Anzeigen im Explorer",
    securityNotifications: "Sicherheit & Benachrichtigungen",
    pushNotifications: "Push-Benachrichtigungen",
    notSupported: "In diesem Browser nicht unterstützt",
    enabled: "Aktiviert",
    blockedInBrowser: "Im Browser blockiert",
    disabled: "Deaktiviert",
    activate: "Aktivieren",
    twoFactorAuth: "Zwei-Faktor-Authentifizierung (TOTP)",
    useAuthApp: "Google Authenticator oder kompatible App verwenden",
    configuring: "Wird konfiguriert...",
    setup2FA: "2FA einrichten",
    scanQR: "QR-Code mit deiner Authentifizierungs-App scannen:",
    sixDigitCode: "6-stelliger Code",
    verify: "Bestätigen",
    twoFAEnabled: "2FA aktiviert",
    twoFAEnabledDesc: "Dein Konto ist jetzt mit Zwei-Faktor geschützt",
    invalidCode: "Ungültiger Code",
    quickSwap: "Schnelltausch",
    connectWalletFirst: "Wallet verbinden",
    noPnlData: "Keine P&L-Daten verfügbar",
    source: "Quelle",
    gas: "Gas",
    installApp: "App installieren",
    exportCsv: "CSV exportieren",
    onboardStep1Title: "Wallets hinzufügen",
    onboardStep1Desc: "Verbinden oder manuell Wallets von Ethereum, Bitcoin, Solana hinzufügen.",
    onboardStep2Title: "Portfolio überwachen",
    onboardStep2Desc: "Salden, Diagramme, P&L und Echtzeitpreise anzeigen.",
    onboardStep3Title: "Sicherheit zuerst",
    onboardStep3Desc: "Ihre Schlüssel werden nie gespeichert. Nur-Lese-Zugriff, immer sicher.",
    onboardNext: "Weiter",
    onboardStart: "Los geht's!",
    search: "Suchen",
    goodMorning: "Guten Morgen",
    goodAfternoon: "Guten Tag",
    goodEvening: "Guten Abend",
  },
  ko: {
    dashboard: "대시보드",
    market: "시장",
    defi: "DeFi & NFTs",
    alerts: "알림",
    news: "뉴스",
    actions: "작업",
    myWallets: "내 지갑",
    totalBalance: "총 잔액",
    wallets: "지갑",
    last24h: "최근 24시간",
    refresh: "새로고침",
    logout: "로그아웃",
    quickActions: "빠른 작업",
    defiPositions: "DeFi 포지션",
    total: "합계",
    rewards: "보상",
    loading: "로딩 중...",
    noPositions: "DeFi 포지션을 찾을 수 없습니다",
    enterAddress: "지갑 주소를 입력하여 DeFi 포지션 확인",
    nftCollection: "NFT 컬렉션",
    items: "개",
    priceAlerts: "가격 알림",
    above: "이상",
    below: "이하",
    createAlert: "알림 만들기",
    noAlerts: "설정된 알림 없음",
    notificationsEnabled: "알림 활성화됨",
    enableNotifications: "알림 활성화",
    cryptoNews: "암호화폐 뉴스",
    send: "보내기",
    swap: "스왑",
    bridge: "브리지",
    sendDesc: "다른 지갑으로 암호화폐 전송",
    swapDesc: "토큰 교환",
    bridgeDesc: "체인 간 이동",
    network: "네트워크",
    destinationAddress: "수신 주소",
    amount: "수량",
    sendTransaction: "트랜잭션 전송",
    from: "보내는",
    to: "받는",
    rate: "환율",
    slippage: "슬리피지",
    estimatedGas: "예상 Gas",
    swapTokens: "토큰 스왑",
    fromChain: "보내는 체인",
    toChain: "받는 체인",
    tokenAmount: "토큰 & 수량",
    estimatedTime: "예상 시간",
    bridgeFee: "브리지 수수료",
    bridgeTokens: "브리지 전송",
    fearGreed: "공포와 탐욕",
    ethGas: "ETH Gas",
    topGainer: "상승률 1위",
    topLoser: "하락률 1위",
    topByMarketCap: "시가총액 상위 10",
    language: "언어",
    currency: "통화",
    english: "English",
    signIn: "로그인",
    createAccount: "계정 만들기",
    name: "이름",
    email: "이메일",
    password: "비밀번호",
    yourName: "이름 입력",
    orContinueWith: "또는 다음으로 계속",
    accountCreated: "계정이 생성되었습니다!",
    checkEmail: "이메일을 확인하여 계정을 인증하세요.",
    backToLogin: "로그인으로 돌아가기",
    tagline: "안전하고 통합된 암호화폐 포트폴리오 ✦",
    addAddress: "주소 추가",
    connectWallet: "지갑 연결",
    addWallet: "지갑 추가",
    walletNamePlaceholder: "이름 (예: 내 MetaMask)",
    addressPlaceholder: "주소 (0x... / bc1... / ...)",
    saveWallet: "저장",
    connectEvm: "EVM 연결",
    connectPhantom: "Phantom 연결",
    detected: "감지됨",
    installExtension: "확장 프로그램 설치",
    private: "비공개",
    share: "공유",
    connected: "연결됨",
    sent: "전송됨",
    received: "수신됨",
    contract: "컨트랙트",
    loadingTransactions: "트랜잭션 로딩 중...",
    errorLoadingTx: "트랜잭션 로딩 오류",
    apiLimits: "무료 API에는 속도 제한이 있습니다",
    noTransactions: "트랜잭션을 찾을 수 없습니다",
    showingLast: "최근",
    transactions: "건의 트랜잭션",
    clickToExplorer: "탐색기에서 보려면 클릭",
    securityNotifications: "보안 및 알림",
    pushNotifications: "푸시 알림",
    notSupported: "이 브라우저에서 지원되지 않음",
    enabled: "활성화됨",
    blockedInBrowser: "브라우저에서 차단됨",
    disabled: "비활성화됨",
    activate: "활성화",
    twoFactorAuth: "2단계 인증 (TOTP)",
    useAuthApp: "Google Authenticator 또는 호환 앱 사용",
    configuring: "설정 중...",
    setup2FA: "2FA 설정",
    scanQR: "인증 앱으로 QR 코드를 스캔하세요:",
    sixDigitCode: "6자리 코드",
    verify: "확인",
    twoFAEnabled: "2FA 활성화됨",
    twoFAEnabledDesc: "계정이 2단계 인증으로 보호됩니다",
    invalidCode: "잘못된 코드",
    quickSwap: "빠른 스왑",
    connectWalletFirst: "지갑 연결",
    noPnlData: "P&L 데이터 없음",
    source: "소스",
    gas: "Gas",
    installApp: "앱 설치",
    exportCsv: "CSV 내보내기",
    onboardStep1Title: "지갑 추가",
    onboardStep1Desc: "Ethereum, Bitcoin, Solana 등의 지갑을 연결하거나 수동으로 추가하세요.",
    onboardStep2Title: "포트폴리오 모니터링",
    onboardStep2Desc: "잔액, 차트, 손익, 실시간 가격을 한눈에 확인하세요.",
    onboardStep3Title: "보안 최우선",
    onboardStep3Desc: "키는 저장되지 않습니다. 읽기 전용, 항상 안전합니다.",
    onboardNext: "다음",
    onboardStart: "시작하기!",
    search: "검색",
    goodMorning: "좋은 아침",
    goodAfternoon: "좋은 오후",
    goodEvening: "좋은 저녁",
  },
} as const;

export type TranslationKey = keyof typeof translations.es | string;

import componentTranslations from "./componentTranslations";

export function t(lang: Lang, key: TranslationKey): string {
  return (translations as any)[lang]?.[key] ?? (componentTranslations as any)[lang]?.[key] ?? (translations as any).en?.[key] ?? (componentTranslations as any).en?.[key] ?? key;
}

export default translations;
